<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex>
        <v-card>
          <v-card-title>
            <h3>Help</h3>
            <Lightbulb medium>
              <template v-slot:message>
                <div>
                  <ul>
                    <li>Forms and Letters can be used to let your customers know about your new payment policy changes.</li>
                    <li>Implementation Guide will show you tips on how to use BlueYonder in your business.</li>
                    <li>Hosted Payment Page and Invoice how to will show you how to implement these features.</li>
                    <li>Favicon can be downloaded and placed on desktop to make a quick link to the BlueYonder Terminal.</li>
                  </ul>
                </div>
              </template>
            </Lightbulb>
          </v-card-title>

          <v-card-text class="pt-0">
            <h4>For Medical Practices</h4>
            <ul>
              <li class="pa-1"><a :href="imageUrl + '/by/Patient intake form.pdf'" download="Patient Intake Form" target="_blank">Patient Intake Form</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/Custom BlueYonder Patient intake form Spanish.pdf'" download="Spanish Patient Intake Form" target="_blank">Spanish Patient Intake Form</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/Letter to inform pre-existing patients.docx'" download="Letter to Inform Pre-Existing Patients" target="_blank">Letter to Inform Pre-Existing Patients</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/Blue Yonder Implementation Guide 2021.pdf'" download="Blue Yonder Implementation Guide 2021" target="_blank">Blue Yonder Implementation Guide</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/BlueYonder Hosted Payment Page Instructions.pdf'" download="BlueYonder Hosted Payment Page Instructions" target="_blank">BlueYonder Hosted Payment Page Instructions</a></li>

              <li class="pa-1"><a :href="imageUrl + '/by/blueyondercorp-favicon.ico'" download="Blue Yonder Favicon" target="_blank">Blue Yonder Favicon</a></li>
            </ul>
            <br />
            <h4>For non-medical business</h4>
            <ul>
              <li class="pa-1"><a :href="imageUrl + '/by/Letter to inform pre-existing customers.docx'" download="Letter to Inform Pre-Existing Customers" target="_blank">Letter to Inform Pre-Existing Customers</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/Business BlueYonder Implementation Guide.pdf'" download="Blue Yonder Implementation Guide 2021" target="_blank">Blue Yonder Implementation Guide</a></li>
              <li class="pa-1"><a :href="imageUrl + '/by/BlueYonder Hosted Payment Page Instructions.pdf'" download="BlueYonder Hosted Payment Page Instructions" target="_blank">BlueYonder Hosted Payment Page Instructions</a></li>

              <li class="pa-1"><a :href="imageUrl + '/by/blueyondercorp-favicon.ico'" download="Blue Yonder Favicon" target="_blank">Blue Yonder Favicon</a></li>
            </ul>
          </v-card-text>

          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex>
        <v-layout column wrap>
          <v-flex>
            <v-card>
              <v-card-title>
                <h3>Signs</h3>
                <Lightbulb medium>
                  <template v-slot:message>
                    <span>Need additional signs for your office? Choose different styles below so you can print and place them in the office.</span>
                  </template>
                </Lightbulb>
              </v-card-title>

              <v-card-text class="pt-0">
                <ul>
                  <li class="pa-1"><a :href="imageUrl + '/by/Blue Yonder Signs V1.1.pdf'" download="Blue Yonder Signs V1" target="_blank">Blue Yonder Signs V1</a></li>
                  <li class="pa-1"><a :href="imageUrl + '/by/Blue Yonder Signs V2.1.pdf'" download="Blue Yonder Signs V2" target="_blank">Blue Yonder Signs V2</a></li>
                  <li class="pa-1"><a :href="imageUrl + '/by/Blue Yonder Signs V3.1.pdf'" download="Blue Yonder Signs V3" target="_blank">Blue Yonder Signs V3</a></li>
                  <li class="pa-1"><a :href="imageUrl + '/by/Blue Yonder Signs V4.1.pdf'" download="Blue Yonder Signs V4" target="_blank">Blue Yonder Signs V4</a></li>
                </ul>
              </v-card-text>

              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-card-title>
                <h3>How-To Video's</h3>
              </v-card-title>

              <v-card-text class="pt-0">
                <ul>
                  <li class="pa-1"><a href="http://somup.com/c3lj0DwuT3" download="How to Run Reports" target="_blank">How to Run Reports</a></li>
                  <li class="pa-1"><a href="http://somup.com/c3lj0bwuT0" download="How to Search Transactions" target="_blank">How to Search Transactions</a></li>
                  <li class="pa-1"><a href="http://somup.com/c0fDrh4TeX" download="Option Feature in Transactions" target="_blank">Option Feature in Transactions</a></li>
                  <li class="pa-1"><a href="http://somup.com/c0fDrZ4TeP" download="How to Use Recurring Payments" target="_blank">How to Use Recurring Payments</a></li>
                  <li class="pa-1"><a href="http://somup.com/c0fDrd4TfN" download="How to Use Installment Payments" target="_blank">How to Use Installment Payments</a></li>
                </ul>
              </v-card-text>

              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Bus from '@/bus'
import Lightbulb from '@/components/help/Lightbulb'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: {Lightbulb},
  mixins: [APIMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      imageUrl: process.env.VUE_APP_IMAGE_URL
    }
  },

  computed: {
    // connected() {
    //   return this.connected
    // },
    environment () {
      return process.env.NODE_ENV
    }
  },

  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Help.vue